import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from '../../assets/img_header_logo.svg';
import './styles.scss';
import jQuery from "jquery";
import { removeBaseUrl } from "../../utils";

const Header = () => {
    const location = useLocation();
    const [ headerMenu, setHeaderMenu ] = useState(null);
    const [openMenu, setOpenMenu] = useState(false);
    const [isFetching, setIsFetching] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        checkMenuActivity();
    }, [location]);

    const checkMenuActivity = () => {
        const pathname = location.pathname;
        jQuery('li.active').removeClass('active');
        jQuery('ul#nav a').each((it, element) => {
            const href = jQuery(element).attr('href');
            const locationPath = removeBaseUrl(href);
            if (locationPath == pathname || (pathname?.includes("/articles/") && locationPath?.includes("/articles/"))) {
                jQuery(element).closest('li.menu-item').addClass('active');
                jQuery(element).closest('li.menu-item-has-children').addClass('active');
            }
        });
    }

    useEffect(() => {
        fetchMenus();
    }, []);

    const fetchMenus = async () => {
        try {
            const { data } = await axios.get("/wp-admin/admin-ajax.php?action=get_menu_content");
            setHeaderMenu(data?.data?.header_menu ?? '');
            setTimeout(() => {
                checkMenuActivity();
                jQuery('nav.header-menu a').on("click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    const href = jQuery(this).attr('href')?.replace("https://www.mylawteam.com/", "");
                    if (href?.length > 0) {
                        navigate(href);
                    } else {
                        navigate("/");
                    }
                    if (jQuery(this).hasClass("search-icon")) {
                        navigate("/articles/");
                    }

                    if (href?.includes("#footer")) {
                        document.querySelector(".footer-form-wrapper").scrollIntoView({behavior: 'smooth', block: 'nearest'})
                    }
                    setOpenMenu(false);
                });

                if (jQuery('li.menu-item-has-children>.arrow').length < 1) {
                    jQuery(`<span class="arrow"> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <g clip-path="url(#clip0_60_3372)">
                        <path d="M4.94 5.72668L8 8.78002L11.06 5.72668L12 6.66668L8 10.6667L4 6.66668L4.94 5.72668Z" fill="#00252A"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_60_3372">
                            <rect width="16" height="16" fill="#00252A"/>
                        </clipPath>
                        </defs>
                    </svg>
                    </span>`).insertAfter('li.menu-item-has-children>a');

                    jQuery('li.menu-item-has-children>.arrow').click(function () {
                        jQuery(this).siblings('.sub-menu').slideToggle(200);
                    });
                }
            }, 100)
        } catch(err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    }

    const openMobileMenu = () => {
        setOpenMenu(!openMenu)
    }

    const onGoToFooter = () => {
        var elementTop = jQuery('#footer').offset()?.top ?? 0;
        var viewportHeight = jQuery(window).height();
        var newScrollTop = elementTop - (viewportHeight / 3);
      
        window.scrollTo({ top: newScrollTop, behavior: 'smooth' })
    }

    return  <>
    
        <header>
            <div className="logo">
                <Link to="/">
                    <img src={Logo} />
                </Link>
            </div>
            <nav className={`header-menu ${openMenu ? 'open' : ''}`} dangerouslySetInnerHTML={{ __html: headerMenu }}></nav>
            <div className="cta-button-wrapper">
                <a href="tel:+12143829789" className="react-button">(214) 382-9789</a>
            </div>
            <span className='mobile-menu-handler' onClick={(event) => {
                event.stopPropagation();
                openMobileMenu()
            }}>
                {!openMenu && <svg width="27" height="19" viewBox="0 0 27 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.375 18.25V15.3333H26.625V18.25H0.375ZM0.375 10.9583V8.04167H26.625V10.9583H0.375ZM0.375 3.66667V0.75H26.625V3.66667H0.375Z" fill="#01517B"/>
                </svg>}

                {openMenu && <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 14 14" fill="none">
                    <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="#01517B"/>
                </svg>}

            </span>
        </header>
        <div className="mobile-cta-button-wrapper">
            <a href="tel:+12143829789" className="react-button">(214) 382-9789</a>
        </div>
    </>
}

export default Header;